module.exports = __webpack_public_path__ + "static/media/Ducklett_gaussian2.24d29529.png";